import { SVGProps } from 'react';

const PhilippinePeso = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20 11H4m16-4H4m3 14V4a1 1 0 0 1 1-1h4a6 6 0 1 1 0 12H7"
    />
  </svg>
);
export default PhilippinePeso;
